<template>
  <div class="document-preview">
    <pdf
      class="elevation-2 doc-thumb"
      v-show="doc.mime_type === 'application/pdf'"
      :src="documentSrc"
      :page="page"
      :style="pdfStyle"
    />
    <v-layout
      v-show="doc.mime_type !== 'application/pdf'"
      class="elevation-2 doc-thumb"
      justify-center
      align-center
    >
      <v-icon>
        {{ fileStateIcon(doc.mime_type) }}
      </v-icon>
    </v-layout>
    <v-chip class="document-state" :color="chipColor" text-color="white" small>
      <strong class="text-uppercase">{{ doc.document_state.state === 'DocGo' ?
                              doc.created_in.abbreviation :
                              doc.created_in.abbreviation + ' (' + doc.document_state.state + ')' }}</strong>
    </v-chip>

    <v-tooltip bottom max-width="500">
      <highlighter
        class="text-truncate"
        slot="activator"
        :searchWords="keywords"
        :textToHighlight="truncate(doc.document_type.name, { length: 24 })"
        autoEscape
        highlightClassName="highlight"
      />
      <span>{{ doc.document_type.name }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import pdf from 'vue-pdf';
import { last, truncate } from 'lodash';
import Highlighter from 'vue-highlight-words';
import fileStateIcon from '@/mixins/file-state-icon';
import getColorByText from '@/assets/utils/colorByText';
import shortName from "../../../utils/short-name";
import acronym from "../../../utils/acronym";

export default {
  name: 'DocumentThumb',
  props: {
    doc: {
      type: Object,
    },
    searchDocumentString: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fileStateIcon,
      last,
      page: 1,
    };
  },
  components: {
    Highlighter,
    pdf,
  },
  methods: {
    shortName,
    acronym,
    truncate,
    getUnitColor(unit) {
      if (!unit) return '#000000';
      return getColorByText(unit.abbreviation || unit.name);
    },
    getDocumentTypeColor(documentType) {
      if (!documentType) return '#000000';
      return getColorByText(documentType.name);
    },
    documentStateColor(state) {
      const statesColor = {
        Minuta: '#FFA000',
        DocGo: '#2196F3',
        Rascunho: '#757575',
        'Rascunho de Minuta': '#757575',
        Desvinculado: '#F44336',
      };
      return statesColor[state] || '#757575';
    },
    getDocumentIcon(mimeType) {
      const icons = {
        'application/pdf': 'mdi-file-pdf-box',
        'application/msword': 'mdi-file-word-box',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'mdi-file-word-box',
        'application/vnd.ms-excel': 'mdi-file-excel-box',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'mdi-file-excel-box',
        'application/vnd.ms-powerpoint': 'mdi-file-powerpoint-box',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'mdi-file-powerpoint-box',
        'image/jpeg': 'mdi-file-image-box',
        'image/png': 'mdi-file-image-box',
        'image/gif': 'mdi-file-image-box',
        'text/plain': 'mdi-file-document-box',
        'text/html': 'mdi-file-document-box',
        'application/zip': 'mdi-zip-box',
        'application/x-rar-compressed': 'mdi-zip-box',
      };
      return icons[mimeType] || 'mdi-file-document-box';
    }
  },
  computed: {
    documentSrc() {
      const lastVersion = last(this.doc.document_versions);
      const loadingTask = pdf.createLoadingTask(lastVersion.file);
      pdf.disableAutoFetch = true;
      return loadingTask;
    },
    chipColor() {
      switch (this.doc.document_state.enum) {
        case 'minute':
          return 'amber';
        default:
          return 'grey darken-2';
      }
    },
    pdfStyle() {
      return {
        border: this.isPending && `2px solid ${this.borderColor}`,
        width: '150px',
        height: '215px',
      };
    },
    borderColor() {
      switch (this.doc.document_state.enum) {
        case 'minute':
          return 'amber';
        default:
          return 'accent';
      }
    },
    isPending() {
      const document = this.doc;
      return document.has_pending_revision || document.has_pending_signature;
    },
    keywords() {
      return this.searchDocumentString.split(' ');
    },
  },
};
</script>

<style>
.document-preview {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.document-version {
  align-self: flex-end;
  margin-bottom: -12px;
  margin-right: -20px;
  z-index: 1;
}
.document-state {
  margin-top: -10px;
}
.highlight {
  background-color: rgba(255, 226, 0, 0.3);
}
.doc-thumb {
  overflow: hidden;
  width: 150px;
  height: 212px;
}
</style>



// WEBPACK FOOTER //
// src/components/document/grid/DocumentThumb.vue